import { render, staticRenderFns } from "./SubscriptionEndingBanner.vue?vue&type=template&id=5a432502&scoped=true"
import script from "./SubscriptionEndingBanner.vue?vue&type=script&lang=js"
export * from "./SubscriptionEndingBanner.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionEndingBanner.vue?vue&type=style&index=0&id=5a432502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a432502",
  null
  
)

export default component.exports